function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { withTheme } from 'styled-components';
import { Small } from '@finect/tabular-core/Small';
import { getFundsSheetPath, getPeriodPerformance } from '@finect/front-resources/Products';
import { Chart, ChartLoadingPlaceholder, ChartNoDataPlaceholder } from '../../../Chart';
import { chartOptions } from './chartOptions';
import { fetchFunds } from './actions';
import { FooterNotesBlock } from './partials';
import { handleClickOnProduct } from './utils';
var FundsColumnsComparison = function (_React$Component) {
  _inherits(FundsColumnsComparison, _React$Component);
  var _super = _createSuper(FundsColumnsComparison);
  function FundsColumnsComparison() {
    var _this;
    _classCallCheck(this, FundsColumnsComparison);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      options: null,
      period: 'M12',
      status: 'initial'
    });
    _defineProperty(_assertThisInitialized(_this), "loadSerie", function (period) {
      var _this$props = _this.props,
        versus = _this$props.versus,
        id = _this$props.id,
        productType = _this$props.productType,
        theme = _this$props.theme;
      fetchFunds(versus, id, productType, period).then(function (funds) {
        var options = chartOptions(theme);
        var values = [];
        var categories = [];
        for (var i = 0; i < funds.length; i++) {
          var type = Number(period.substring(1, 3)) <= 12 ? 'accumulated' : 'annualized';
          var performancePeriod = getPeriodPerformance(funds[i], period, type);
          if (performancePeriod) {
            categories.push(funds[i].name);
            values.push({
              category: funds[i].name,
              name: funds[i].name,
              y: performancePeriod.value,
              product: {
                id: funds[i].id,
                subtype: productType.id,
                url: getFundsSheetPath(theme, productType, funds[i]),
                alias: funds[i].alias,
                isin: funds[i].isin
              },
              events: {
                click: function click(event) {
                  handleClickOnProduct(event.point.product.url);
                }
              }
            });
          }
        }
        options.xAxis = _objectSpread(_objectSpread({}, options.xAxis), {
          categories: categories
        });
        options.series.push({
          name: 'Rentabilidad',
          data: values
        });
        _this.setState({
          options: options,
          status: 'loaded'
        });
      });
    });
    return _this;
  }
  _createClass(FundsColumnsComparison, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.period !== this.props.period) {
        this.setState({
          period: this.props.period
        });
        this.loadSerie(this.props.period);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadSerie(this.props.period);
    }
  }, {
    key: "render",
    value: function render() {
      var footerNotes = this.props.footerNotes;
      if (this.state.status === 'loaded') {
        return React.createElement("div", null, React.createElement(Chart, {
          options: this.state.options
        }), footerNotes ? React.createElement(FooterNotesBlock, null, React.createElement(Small, {
          light: true
        }, footerNotes)) : null);
      }
      if (this.state.status === 'noDataAvailable') {
        return React.createElement(ChartNoDataPlaceholder, null);
      }
      return React.createElement(ChartLoadingPlaceholder, null);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.period !== prevState.period) {
        return {
          period: nextProps.period,
          status: 'initial'
        };
      }
      return null;
    }
  }]);
  return FundsColumnsComparison;
}(React.Component);
export default withTheme(FundsColumnsComparison);